import { useAuth as useUserAuth } from '../Contexts/UserContext';

// Re-export for backward compatibility
export const useAuth = useUserAuth;
